<template>
  <div class="malicious-container">
    <!-- 背景装饰 -->
    <div class="leftSider">
      <img src="@assets/leftSider.png" alt="">
    </div>
    <div class="rightSider">
      <img src="@assets/rightSider.png" alt="">
    </div>

    <!-- Header -->
    <dp-header :title="'恶意域名检测（101.7.8.9）'"></dp-header>

    <div class="page-update-time">数据更新时间：{{ currentDateText }}</div>

    <!-- 时间范围切换 -->
    <div class="range-switch">
      <el-button
        v-for="item in rangeOptions"
        :key="item.value"
        size="small"
        :type="rangeDays === item.value ? 'primary' : ''"
        @click="setRange(item.value)"
      >{{ item.label }}</el-button>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧：类型饼图 + 趋势折线 -->
      <div class="left-section">
        <div class="section-card left-card">
          <div class="card-title">
            <span class="title-main">恶意域名类型及数量统计</span>
            <span class="subtitle" v-if="typeTotal > 0">（共 <span class="highlight">{{ typeTotal }}</span> 个）</span>
          </div>
          <div class="chart-container" ref="pieContainer" v-loading="pieLoading"></div>
        </div>
        <div class="section-card left-card">
          <div class="card-title">
            <span class="title-main">检测模型发现的恶意域名数量趋势</span>
          </div>
          <div class="chart-container" ref="trendContainer" v-loading="trendLoading"></div>
        </div>
      </div>

      <!-- 中间：中国地图 -->
      <div class="center-section">
        <div class="section-card">
          <div class="card-title">
            <span class="title-main">访问恶意域名的 IP 归属地图</span>
            <span class="subtitle" v-if="provinceTotalIps > 0">（共 <span class="highlight">{{ provinceTotalIps }}</span> 个源 IP）</span>
          </div>
          <div class="map-container" ref="mapContainer" v-loading="mapLoading"></div>
        </div>
      </div>

      <!-- 右侧：网段表格 / 拓扑图（同一板块内切换） -->
      <div class="right-section">
        <div class="section-card right-card">
          <div class="card-title">
            <span class="title-main">{{ rightTab === 'cidr' ? '恶意域名使用的 IP 统计（网段维度）' : '恶意域名热门 IP 拓扑图' }}</span>
            <span class="subtitle" v-if="rightTab === 'cidr' && cidrData.length > 0">（共 <span class="highlight">{{ cidrData.length }}</span> 个网段）</span>
            <span class="subtitle" v-else-if="rightTab === 'topo' && topoDomainCount > 0">（{{ topoDomainCount }} 域名 / {{ topoIpCount }} IP）</span>
            <div class="tab-switch">
              <button
                v-for="tab in rightTabs"
                :key="tab.value"
                type="button"
                :class="{ active: rightTab === tab.value }"
                @click="switchRightTab(tab.value)"
              >{{ tab.label }}</button>
            </div>
          </div>

          <div class="tab-panel" v-show="rightTab === 'cidr'">
            <el-table
              :data="pagedCidrData"
              v-loading="cidrLoading"
              style="width: 100%"
              class="mal-table cidr-table"
            >
              <el-table-column prop="cidr16" label="网段" min-width="120"></el-table-column>
              <el-table-column prop="domain_count" label="使用域名数量" min-width="90" align="center"></el-table-column>
              <el-table-column label="域名列表" min-width="160">
                <template slot-scope="scope">
                  <el-tooltip placement="top" effect="dark" popper-class="domain-list-tooltip" :open-delay="200">
                    <div slot="content" class="domain-list-tooltip-content">
                      {{ scope.row.domains.join('\n') }}
                    </div>
                    <span class="domain-list-preview">{{ formatDomainPreview(scope.row.domains) }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="cidrData.length > cidrPageSize"
              small
              layout="prev, pager, next"
              :current-page="cidrCurrentPage"
              :page-size="cidrPageSize"
              :total="cidrData.length"
              @current-change="handleCidrPageChange"
              class="mal-pagination"
            />
          </div>

          <div class="tab-panel" v-show="rightTab === 'topo'">
            <div class="chart-container topo-chart" ref="topoContainer" v-loading="topoLoading"></div>
          </div>
        </div>
      </div>

      <!-- 底部：恶意域名通报表格 -->
      <div class="bottom-section">
        <div class="section-card bottom-card">
          <div class="card-title">
            <span class="title-main">检测模型发现的恶意域名通报</span>
            <span class="subtitle" v-if="eventsTotal > 0">（共 <span class="highlight">{{ eventsTotal }}</span> 条事件）</span>
          </div>
          <el-table
            ref="eventTable"
            :data="eventsData"
            v-loading="eventsLoading"
            style="width: 100%"
            class="mal-table event-table"
          >
            <el-table-column prop="timeText" label="时间" min-width="125"></el-table-column>
            <el-table-column prop="domain" label="域名" min-width="160"></el-table-column>
            <el-table-column label="解析次数" min-width="100" align="center">
              <template slot-scope="scope">
                <el-tooltip
                  placement="top"
                  effect="dark"
                  popper-class="domain-list-tooltip"
                  :open-delay="200"
                  :disabled="!scope.row.dailyAccessText"
                >
                  <div slot="content" class="domain-list-tooltip-content">
                    {{ scope.row.dailyAccessText }}
                  </div>
                  <span class="access-count">{{ scope.row.accessCountText }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="解析IP" min-width="200">
              <template slot-scope="scope">
                <el-tooltip
                  placement="top"
                  effect="dark"
                  popper-class="domain-list-tooltip"
                  :open-delay="200"
                  :disabled="!scope.row.ipOverflow"
                >
                  <div slot="content" class="domain-list-tooltip-content">
                    {{ scope.row.resolvedAll }}
                  </div>
                  <div class="multi-grid ip-grid">
                    <span v-for="(ip, idx) in scope.row.resolvedIps" :key="idx" class="multi-item">{{ ip }}</span>
                    <span v-if="scope.row.ipOverflow" class="multi-item more">+{{ scope.row.ipMoreCount }}</span>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="IP归属地" min-width="150">
              <template slot-scope="scope">
                <el-tooltip
                  placement="top"
                  effect="dark"
                  popper-class="domain-list-tooltip"
                  :open-delay="200"
                  :disabled="!scope.row.locationOverflow"
                >
                  <div slot="content" class="domain-list-tooltip-content">
                    {{ scope.row.locationAll }}
                  </div>
                  <div class="multi-grid location-grid">
                    <span v-for="(loc, idx) in scope.row.locations" :key="idx" class="multi-item">{{ loc }}</span>
                    <span v-if="scope.row.locationOverflow" class="multi-item more">+{{ scope.row.locationMoreCount }}</span>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="registeredText" label="域名注册时间" min-width="105"></el-table-column>
            <el-table-column label="置信度" min-width="90">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.confidenceText" placement="top" :open-delay="200" effect="dark">
                  <div class="confidence-bar">
                    <span
                      class="confidence-fill"
                      :class="scope.row.confidenceClass"
                      :style="{ width: scope.row.confidenceWidth }"
                    ></span>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="domain_type" label="域名类型" min-width="90">
              <template slot-scope="scope">
                <span class="type-tag">{{ scope.row.domain_type }}</span>
              </template>
            </el-table-column>
            <el-table-column label="检测模型" min-width="85" align="center">
              <template slot-scope="scope">
                <span class="model-tag" :class="scope.row.modelClass">{{ scope.row.modelText }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="eventsTotal > 0"
            @current-change="handleEventsPageChange"
            :current-page="eventsCurrentPage"
            :page-size="eventsPageSize"
            layout="total, prev, pager, next"
            :total="eventsTotal"
            class="mal-pagination"
          />
        </div>

        <!-- 黑帽SEO通报表格（数据源为本地离线索引文件，非上游接口） -->
        <div class="section-card bottom-card">
          <div class="card-title">
            <span class="title-main">黑帽SEO通报</span>
            <span class="subtitle" v-if="seoTotal > 0">（共 <span class="highlight">{{ seoTotal.toLocaleString() }}</span> 条记录）</span>
            <span
              class="subtitle"
              v-if="seoStats && seoStats.builtAt"
            >（数据构建于 {{ formatBuildTime(seoStats.builtAt) }}）</span>
          </div>

          <!-- 筛选栏 -->
          <div class="seo-filter-bar" v-loading="seoStatsLoading">
            <el-input
              v-model="seoFilters.q"
              size="small"
              class="seo-search"
              clearable
              placeholder="搜索域名（如 edu.cn）"
              @input="scheduleSeoReload"
            >
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
            <el-select
              v-model="seoFilters.engine"
              size="small"
              clearable
              placeholder="搜索引擎"
              @change="loadAbuseSeo(1)"
            >
              <el-option
                v-for="item in seoEngineOptions"
                :key="item.value"
                :label="`${item.value}（${item.count.toLocaleString()}）`"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="seoFilters.scope"
              size="small"
              clearable
              placeholder="站点类型"
              @change="loadAbuseSeo(1)"
            >
              <el-option
                v-for="item in seoScopeOptions"
                :key="item.value"
                :label="`${item.value}（${item.count.toLocaleString()}）`"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="seoFilters.category"
              size="small"
              clearable
              placeholder="违规类型"
              @change="loadAbuseSeo(1)"
            >
              <el-option
                v-for="item in seoCategoryOptions"
                :key="item.value"
                :label="`${seoCategoryLabel(item.value)}（${item.count.toLocaleString()}）`"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="seoFilters.round"
              size="small"
              clearable
              placeholder="采集轮次"
              @change="loadAbuseSeo(1)"
            >
              <el-option
                v-for="item in seoRoundOptions"
                :key="item.value"
                :label="`第 ${item.value} 轮（${item.count.toLocaleString()}）`"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button size="small" icon="el-icon-refresh-left" @click="resetSeoFilters">重置</el-button>
          </div>

          <el-table
            ref="seoTable"
            :data="seoData"
            v-loading="seoLoading"
            style="width: 100%"
            class="mal-table seo-table"
          >
            <el-table-column prop="round" label="采集轮次" min-width="90" align="center"></el-table-column>
            <el-table-column prop="engine" label="搜索引擎" min-width="90" align="center">
              <template slot-scope="scope">
                <span class="engine-tag">{{ scope.row.engine }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="scope" label="站点类型" min-width="90" align="center">
              <template slot-scope="scope">
                <span class="scope-tag">{{ scope.row.scope }}</span>
              </template>
            </el-table-column>
            <el-table-column label="域名" min-width="170">
              <template slot-scope="scope">
                <span class="seo-domain">{{ scope.row.fqdn }}</span>
              </template>
            </el-table-column>
            <el-table-column label="命中位置" min-width="90" align="center">
              <template slot-scope="scope">
                <span class="location-tag">{{ scope.row.location }}</span>
              </template>
            </el-table-column>
            <el-table-column label="违规类型" min-width="105" align="center">
              <template slot-scope="scope">
                <span class="category-tag" :class="scope.row.categoryClass">{{ scope.row.categoryText }}</span>
              </template>
            </el-table-column>
            <el-table-column label="页面标题" min-width="200">
              <template slot-scope="scope">
                <el-tooltip
                  placement="top"
                  effect="dark"
                  popper-class="domain-list-tooltip"
                  :open-delay="200"
                  :disabled="!scope.row.titleOverflow"
                >
                  <div slot="content" class="domain-list-tooltip-content">{{ scope.row.title }}</div>
                  <span class="seo-title">{{ scope.row.titleShort }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="页面描述" min-width="220">
              <template slot-scope="scope">
                <el-tooltip
                  placement="top"
                  effect="dark"
                  popper-class="domain-list-tooltip"
                  :open-delay="200"
                  :disabled="!scope.row.descOverflow"
                >
                  <div slot="content" class="domain-list-tooltip-content">{{ scope.row.desc }}</div>
                  <span class="seo-desc">{{ scope.row.descShort }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="链接" min-width="90" align="center">
              <template slot-scope="scope">
                <a
                  v-if="scope.row.url"
                  class="seo-link"
                  :href="scope.row.url"
                  target="_blank"
                  rel="noreferrer noopener"
                >打开</a>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="seoTotal > 0"
            background
            :current-page="seoCurrentPage"
            :page-size="seoPageSize"
            :page-sizes="[20, 50, 100]"
            :total="seoTotal"
            layout="total, sizes, prev, pager, next"
            @size-change="handleSeoSizeChange"
            @current-change="handleSeoPageChange"
            class="mal-pagination"
          />
        </div>
      </div>

      <footer class="beian-footer">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">鲁ICP备2026032922号-1</a>
        <span>|</span>
        <a
          class="beian-police-link"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=37140202001764"
          rel="noreferrer"
          target="_blank"
        >
          <img class="beian-police-logo" src="/beian-police.png" alt="公安备案图标" />
          <span>鲁公网安备37140202001764号</span>
        </a>
      </footer>
    </div>

    <!-- 底部导航 -->
    <navigation ref="nav"></navigation>
  </div>
</template>

<script>
import * as echarts from "echarts";
import chinaMapData from "@/assets/models/geoJson/china.json";

import {
  getMaliciousProvinceIps,
  getMaliciousCidr16DomainCounts,
  getMaliciousDomainIpTopology,
  getMaliciousTypeCounts,
  getMaliciousDailyTrend,
  getMaliciousEvents,
  getAbuseSeoEvents,
  getAbuseSeoStats
} from "@/service/dashboard";

// API 返回省份为全称，与 echarts 中国地图名称一致；此处兜底处理简称
const PROVINCE_ALIAS = {
  "香港": "香港特别行政区",
  "澳门": "澳门特别行政区",
  "台湾": "台湾省"
};

// 通报表格中「解析IP / IP归属地」单元格最多平铺展示的条目数，超出折叠为 +N 并在悬浮时展示全部
const MULTI_CELL_LIMIT = 6;

export default {
  name: "MaliciousDomain",
  data() {
    return {
      // 时间范围
      rangeDays: 7,
      rangeOptions: [
        { label: "近7天", value: 7 },
        { label: "近30天", value: 30 },
        { label: "近90天", value: 90 }
      ],

      // echarts 实例
      pieChart: null,
      trendChart: null,
      mapChart: null,
      topoChart: null,

      // 各模块 loading
      pieLoading: false,
      trendLoading: false,
      mapLoading: false,
      cidrLoading: false,
      topoLoading: false,
      eventsLoading: false,

      // 类型统计
      typeTotal: 0,

      // 地图
      provinceTotalIps: 0,

      // 网段表格
      cidrData: [],
      cidrCurrentPage: 1,
      cidrPageSize: 12,

      // 右侧板块切换
      rightTab: "cidr",
      rightTabs: [
        { label: "网段统计", value: "cidr" },
        { label: "拓扑图", value: "topo" }
      ],

      // 拓扑
      topoDomainCount: 0,
      topoIpCount: 0,
      topoOption: null,

      // 事件通报（服务端分页）
      eventsData: [],
      eventsTotal: 0,
      eventsCurrentPage: 1,
      // 必须为 20：上游 /api/malicious/events 仅对 page=1&page_size=20 预热了缓存（X-Cache: HIT），
      // 其他 page_size 会击穿缓存触发全量聚合，耗时 37~63 秒
      eventsPageSize: 20,

      // 黑帽SEO通报（本地离线索引，服务端分页）
      seoData: [],
      seoTotal: 0,
      seoCurrentPage: 1,
      seoPageSize: 20,
      seoLoading: false,
      seoStats: null,
      seoStatsLoading: false,
      seoFilters: {
        engine: "",
        scope: "",
        category: "",
        round: "",
        q: ""
      },
      seoFilterTimer: null,
      // 竞态保护：只接受最后一次请求的响应
      seoRequestSeq: 0,

      resizeTimer: null
    };
  },
  computed: {
    currentDateText() {
      const now = new Date();
      const offset = (now.getDay() + 6) % 7;
      const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - offset);
      const pad = value => String(value).padStart(2, "0");

      return `${monday.getFullYear()}-${pad(monday.getMonth() + 1)}-${pad(monday.getDate())}`;
    },
    pagedCidrData() {
      const start = (this.cidrCurrentPage - 1) * this.cidrPageSize;

      return this.cidrData.slice(start, start + this.cidrPageSize);
    },
    // 黑帽SEO 筛选下拉选项（含计数），数据来自 /abuse-api/seo-stats
    seoEngineOptions() {
      return (this.seoStats && this.seoStats.engines) || [];
    },
    seoScopeOptions() {
      return (this.seoStats && this.seoStats.scopes) || [];
    },
    seoRoundOptions() {
      return (this.seoStats && this.seoStats.rounds) || [];
    },
    seoCategoryOptions() {
      return (this.seoStats && this.seoStats.categories) || [];
    }
  },
  mounted() {
    console.log("[DEBUG] MaliciousDomain mounted 开始");
    this.$nextTick(() => {
      setTimeout(async () => {
        this.initCharts();
        await this.loadAll();
        this.$nextTick(() => this.resizeAllCharts());
        console.log("[DEBUG] MaliciousDomain mounted 完成");
      }, 50);
    });
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    ["pieChart", "trendChart", "mapChart", "topoChart"].forEach(key => {
      if (this[key]) {
        this[key].dispose();
      }
    });
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getChinaMapLayout() {
      return {
        layoutCenter: ["50%", "70%"],
        layoutSize: "115%"
      };
    },

    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => this.resizeAllCharts(), 100);
    },

    resizeAllCharts() {
      ["pieChart", "trendChart", "mapChart", "topoChart"].forEach(key => {
        if (this[key]) {
          this[key].resize();
        }
      });
    },

    initCharts() {
      console.log("[DEBUG] initCharts 开始");
      echarts.registerMap("china", chinaMapData);
      this.pieChart = echarts.init(this.$refs.pieContainer);
      this.trendChart = echarts.init(this.$refs.trendContainer);
      this.mapChart = echarts.init(this.$refs.mapContainer);
      // 拓扑图默认隐藏，容器无尺寸，延迟到首次切换时再初始化
      console.log("[DEBUG] initCharts 完成");
    },

    // 右侧板块切换：网段统计 / 拓扑图
    switchRightTab(tab) {
      if (this.rightTab === tab) {
        return;
      }
      this.rightTab = tab;
      if (tab !== "topo") {
        return;
      }
      this.$nextTick(() => {
        if (!this.topoChart) {
          this.topoChart = echarts.init(this.$refs.topoContainer);
          if (this.topoOption) {
            this.topoChart.setOption(this.topoOption, true);
          }
        } else {
          this.topoChart.resize();
        }
      });
    },

    // 时间范围切换：全量刷新
    setRange(days) {
      if (this.rangeDays === days) {
        return;
      }
      console.log("[DEBUG] setRange:", days);
      this.rangeDays = days;
      this.eventsCurrentPage = 1;
      this.cidrCurrentPage = 1;
      // 黑帽SEO 无时间维度，时间范围切换不影响它，保持当前页
      this.loadAll();
    },

    async loadAll() {
      console.log("[DEBUG] loadAll 开始, range_days =", this.rangeDays);
      try {
        await Promise.all([
          this.loadTypeCounts(),
          this.loadDailyTrend(),
          this.loadProvinceMap(),
          this.loadCidr16(),
          this.loadTopology(),
          this.loadEvents(1),
          this.loadAbuseSeo(1)
        ]);
        // 筛选下拉的选项与计数，单独拉一次即可，失败不阻塞主流程
        this.loadAbuseSeoStats();
        console.log("[DEBUG] loadAll 完成");
      } catch (error) {
        console.error("[DEBUG] loadAll 出错:", error);
      }
    },

    // ============ 1. 类型统计饼图 ============
    async loadTypeCounts() {
      console.log("[DEBUG] loadTypeCounts 开始");
      this.pieLoading = true;
      try {
        const res = await getMaliciousTypeCounts({ range_days: this.rangeDays });

        console.log("[DEBUG] loadTypeCounts API返回:", res);
        const items = (res && res.items) || [];

        this.typeTotal = (res && res.total) || items.reduce((s, i) => s + (i.count || 0), 0);
        this.updatePieChart(items);
        console.log("[DEBUG] loadTypeCounts 完成, 类型数:", items.length);
      } catch (error) {
        console.error("[DEBUG] loadTypeCounts 出错:", error);
        this.updatePieChart([]);
      } finally {
        this.pieLoading = false;
      }
    },

    updatePieChart(items) {
      const palette = ["#FF6B6B", "#FAAD14", "#1890FF", "#52C41A", "#722ED1", "#13C2C2", "#EB2F96"];
      const data = items.map(i => ({ name: i.domain_type, value: i.count }));

      this.pieChart.setOption({
        color: palette,
        tooltip: {
          trigger: "item",
          formatter: "{b}<br/>数量: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          right: 8,
          top: "center",
          textStyle: { color: "rgba(255,255,255,0.75)", fontSize: 12 },
          itemWidth: 12,
          itemHeight: 12
        },
        series: [
          {
            name: "恶意域名类型",
            type: "pie",
            radius: ["38%", "62%"],
            center: ["36%", "52%"],
            avoidLabelOverlap: true,
            itemStyle: {
              borderColor: "rgba(0,0,0,0.35)",
              borderWidth: 2
            },
            label: {
              color: "#fff",
              fontSize: 12,
              formatter: "{b}\n{c}"
            },
            labelLine: { lineStyle: { color: "rgba(255,255,255,0.4)" } },
            data
          }
        ]
      }, true);
    },

    // ============ 2. 每日趋势折线 ============
    async loadDailyTrend() {
      console.log("[DEBUG] loadDailyTrend 开始");
      this.trendLoading = true;
      try {
        const res = await getMaliciousDailyTrend({ range_days: this.rangeDays });

        console.log("[DEBUG] loadDailyTrend API返回:", res);
        const items = (res && res.items) || [];

        this.updateTrendChart(items);
        console.log("[DEBUG] loadDailyTrend 完成, 天数:", items.length);
      } catch (error) {
        console.error("[DEBUG] loadDailyTrend 出错:", error);
        this.updateTrendChart([]);
      } finally {
        this.trendLoading = false;
      }
    },

    updateTrendChart(items) {
      const dates = items.map(i => i.date);
      const spike = items.map(i => i.dns_spike_count);
      const gnn = items.map(i => i.gnn_count);

      this.trendChart.setOption({
        color: ["#1890FF", "#FAAD14"],
        tooltip: { trigger: "axis" },
        legend: {
          data: ["dnsspike", "GNN"],
          top: 4,
          textStyle: { color: "rgba(255,255,255,0.75)" }
        },
        grid: { left: 40, right: 20, top: 40, bottom: 30 },
        xAxis: {
          type: "category",
          data: dates,
          axisLabel: { color: "rgba(255,255,255,0.6)", fontSize: 10 },
          axisLine: { lineStyle: { color: "rgba(255,255,255,0.2)" } }
        },
        yAxis: {
          type: "value",
          name: "恶意域名数量",
          nameTextStyle: { color: "rgba(255,255,255,0.6)", fontSize: 10 },
          axisLabel: { color: "rgba(255,255,255,0.6)", fontSize: 10 },
          splitLine: { lineStyle: { color: "rgba(255,255,255,0.08)" } }
        },
        series: [
          { name: "dnsspike", type: "line", smooth: true, symbolSize: 6, data: spike, areaStyle: { opacity: 0.08 } },
          { name: "GNN", type: "line", smooth: true, symbolSize: 6, data: gnn, areaStyle: { opacity: 0.08 } }
        ]
      }, true);
    },

    // ============ 3. IP 归属地图 ============
    async loadProvinceMap() {
      console.log("[DEBUG] loadProvinceMap 开始");
      this.mapLoading = true;
      try {
        const res = await getMaliciousProvinceIps({ range_days: this.rangeDays });

        console.log("[DEBUG] loadProvinceMap API返回:", res);
        const items = (res && res.items) || [];
        const mapData = items.map(i => ({
          name: PROVINCE_ALIAS[i.province] || i.province,
          value: i.ip_count,
          ips: i.ips || []
        }));

        this.provinceTotalIps = items.reduce((s, i) => s + (i.ip_count || 0), 0);
        this.updateMapChart(mapData);
        console.log("[DEBUG] loadProvinceMap 完成, 省份数:", mapData.length);
      } catch (error) {
        console.error("[DEBUG] loadProvinceMap 出错:", error);
        this.updateMapChart([]);
      } finally {
        this.mapLoading = false;
      }
    },

    updateMapChart(data) {
      const values = data.map(d => d.value).filter(v => typeof v === "number" && !isNaN(v));
      const maxValue = values.length > 0 ? Math.max(...values) : 10;

      this.mapChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            if (params.value === undefined || isNaN(params.value)) {
              return `${params.name}<br/>源IP数: 0`;
            }
            return `${params.name}<br/>源IP数: ${params.value}`;
          }
        },
        visualMap: {
          min: 0,
          max: Math.max(maxValue, 10),
          text: ["高", "低"],
          realtime: false,
          calculable: true,
          inRange: { color: ["#ffe0e0", "#ff4d4f", "#a8071a"] },
          textStyle: { color: "#fff" },
          bottom: 20,
          left: 20
        },
        series: [
          {
            name: "源IP数",
            type: "map",
            map: "china",
            roam: true,
            ...this.getChinaMapLayout(),
            itemStyle: {
              areaColor: "#1e3a8a",
              borderColor: "#4da6ff",
              borderWidth: 1
            },
            emphasis: {
              itemStyle: { areaColor: "#40a9ff", borderColor: "#fff", borderWidth: 2 },
              label: { show: true, color: "#fff" }
            },
            label: { show: false },
            data
          }
        ]
      }, true);
    },

    // ============ 4. 网段表格 ============
    async loadCidr16() {
      console.log("[DEBUG] loadCidr16 开始");
      this.cidrLoading = true;
      try {
        const res = await getMaliciousCidr16DomainCounts({ range_days: this.rangeDays, limit: 200 });

        console.log("[DEBUG] loadCidr16 API返回:", res);
        const items = (res && res.items) || [];

        this.cidrData = items.map(i => ({
          cidr16: i.cidr16,
          domain_count: i.domain_count,
          domains: Array.isArray(i.domains) ? i.domains : []
        }));
        this.cidrCurrentPage = 1;
        console.log("[DEBUG] loadCidr16 完成, 网段数:", this.cidrData.length);
      } catch (error) {
        console.error("[DEBUG] loadCidr16 出错:", error);
        this.cidrData = [];
      } finally {
        this.cidrLoading = false;
      }
    },

    handleCidrPageChange(page) {
      this.cidrCurrentPage = page;
    },

    formatDomainPreview(domains) {
      if (!domains || domains.length === 0) {
        return "—";
      }
      const preview = domains.slice(0, 2).join("、");

      return domains.length > 2 ? `${preview} 等${domains.length}个` : preview;
    },

    // ============ 5. IP 拓扑图 ============
    async loadTopology() {
      console.log("[DEBUG] loadTopology 开始");
      this.topoLoading = true;
      try {
        const res = await getMaliciousDomainIpTopology({ range_days: this.rangeDays, limit: 60 });

        console.log("[DEBUG] loadTopology API返回:", res);
        const items = (res && res.items) || [];

        this.updateTopoChart(items);
        console.log("[DEBUG] loadTopology 完成, 域名数:", items.length);
      } catch (error) {
        console.error("[DEBUG] loadTopology 出错:", error);
        this.updateTopoChart([]);
      } finally {
        this.topoLoading = false;
      }
    },

    updateTopoChart(items) {
      // 限制展示域名数量，保证可读性
      const MAX_DOMAINS = 40;
      const domains = items.slice(0, MAX_DOMAINS);
      const nodes = [];
      const links = [];
      const ipSet = new Map();

      domains.forEach(d => {
        nodes.push({
          id: `d:${d.domain}`,
          name: d.domain,
          category: 0,
          symbolSize: 16,
          value: (d.ips || []).length
        });
        (d.ips || []).forEach(ip => {
          const ipId = `i:${ip}`;

          if (!ipSet.has(ipId)) {
            ipSet.set(ipId, { id: ipId, name: ip, category: 1, symbolSize: 10, degree: 0 });
          }
          ipSet.get(ipId).degree += 1;
          links.push({ source: `d:${d.domain}`, target: ipId });
        });
      });
      // IP 节点按被解析次数放大
      ipSet.forEach(node => {
        node.symbolSize = Math.min(30, 8 + node.degree * 3);
        nodes.push(node);
      });

      this.topoDomainCount = domains.length;
      this.topoIpCount = ipSet.size;

      const option = {
        tooltip: {
          formatter: (params) => {
            if (params.dataType === "node") {
              const isDomain = params.data.category === 0;

              return isDomain
                ? `域名: ${params.data.name}<br/>解析IP数: ${params.data.value}`
                : `IP: ${params.data.name}<br/>被解析次数: ${params.data.degree}`;
            }
            return "";
          }
        },
        legend: {
          data: ["恶意域名", "解析IP"],
          top: 4,
          textStyle: { color: "rgba(255,255,255,0.75)" }
        },
        series: [
          {
            type: "graph",
            layout: "force",
            roam: true,
            draggable: true,
            categories: [
              { name: "恶意域名", itemStyle: { color: "#FF6B6B" } },
              { name: "解析IP", itemStyle: { color: "#40a9ff" } }
            ],
            force: { repulsion: 80, edgeLength: [30, 80], gravity: 0.08 },
            label: {
              show: false,
              color: "#fff",
              fontSize: 10,
              position: "right"
            },
            emphasis: {
              focus: "adjacency",
              label: { show: true }
            },
            lineStyle: { color: "rgba(255,255,255,0.25)", width: 1, curveness: 0.05 },
            data: nodes,
            links
          }
        ]
      };

      this.topoOption = option;
      if (this.topoChart) {
        this.topoChart.setOption(option, true);
      }
    },

    // ============ 6. 事件通报表格（服务端分页）============
    async loadEvents(page) {
      console.log("[DEBUG] loadEvents 开始, page:", page);
      this.eventsLoading = true;
      try {
        const res = await getMaliciousEvents({
          range_days: this.rangeDays,
          page: page,
          page_size: this.eventsPageSize
        });

        console.log("[DEBUG] loadEvents API返回:", res);
        const items = (res && res.items) || [];

        this.eventsData = items.map(e => this.toEventRow(e));
        this.eventsTotal = (res && res.total) || 0;
        this.eventsCurrentPage = page;
        this.$nextTick(() => {
          const body = this.$refs.eventTable && this.$refs.eventTable.$el
            ? this.$refs.eventTable.$el.querySelector(".el-table__body-wrapper")
            : null;

          if (body) {
            body.scrollTop = 0;
          }
        });
        console.log("[DEBUG] loadEvents 完成, 条数:", items.length);
      } catch (error) {
        console.error("[DEBUG] loadEvents 出错:", error);
        this.eventsData = [];
        this.eventsTotal = 0;
      } finally {
        this.eventsLoading = false;
      }
    },

    handleEventsPageChange(page) {
      this.loadEvents(page);
    },

    // ============ 7. 黑帽SEO通报表格（本地离线索引，服务端分页）============
    async loadAbuseSeoStats() {
      this.seoStatsLoading = true;
      try {
        const res = await getAbuseSeoStats();

        this.seoStats = res || null;
      } catch (error) {
        console.error("[DEBUG] loadAbuseSeoStats 出错:", error);
        this.seoStats = null;
      } finally {
        this.seoStatsLoading = false;
      }
    },

    // 筛选条件变化后 300ms 防抖，回到第 1 页重查
    scheduleSeoReload() {
      if (this.seoFilterTimer) {
        clearTimeout(this.seoFilterTimer);
      }
      this.seoFilterTimer = setTimeout(() => {
        this.loadAbuseSeo(1);
      }, 300);
    },

    resetSeoFilters() {
      this.seoFilters = { engine: "", scope: "", category: "", round: "", q: "" };
      this.loadAbuseSeo(1);
    },

    // 空值参数不下发，避免后端把空字符串当有效筛选
    buildSeoParams(page) {
      const params = {
        page: page,
        size: this.seoPageSize
      };
      const f = this.seoFilters;

      if (f.engine) {
        params.engine = f.engine;
      }
      if (f.scope) {
        params.scope = f.scope;
      }
      if (f.round !== "" && f.round !== null && f.round !== undefined) {
        params.round = f.round;
      }
      // 违规类型筛选：一个类型（如 gambling）在数据里对应多个 label
      // （part_gambling / title_gambling / desc_gambling），故传 category 由后端聚合匹配
      if (f.category) {
        params.category = f.category;
      }
      if (f.q && f.q.trim()) {
        params.q = f.q.trim();
      }
      return params;
    },

    async loadAbuseSeo(page) {
      const seq = ++this.seoRequestSeq;

      this.seoLoading = true;
      try {
        const res = await getAbuseSeoEvents(this.buildSeoParams(page));

        // 竞态保护：期间又发了新请求就丢弃本次响应
        if (seq !== this.seoRequestSeq) {
          return;
        }
        const items = (res && res.items) || [];

        this.seoData = items.map(e => this.toSeoRow(e));
        this.seoTotal = (res && res.total) || 0;
        this.seoCurrentPage = page;
        this.$nextTick(() => {
          const body = this.$refs.seoTable && this.$refs.seoTable.$el
            ? this.$refs.seoTable.$el.querySelector(".el-table__body-wrapper")
            : null;

          if (body) {
            body.scrollTop = 0;
          }
        });
      } catch (error) {
        if (seq !== this.seoRequestSeq) {
          return;
        }
        console.error("[DEBUG] loadAbuseSeo 出错:", error);
        this.seoData = [];
        this.seoTotal = 0;
      } finally {
        if (seq === this.seoRequestSeq) {
          this.seoLoading = false;
        }
      }
    },

    handleSeoPageChange(page) {
      this.loadAbuseSeo(page);
    },

    handleSeoSizeChange(size) {
      this.seoPageSize = size;
      this.loadAbuseSeo(1);
    },

    // 违规类型的展示名：把 "fake scam" 这类英文枚举映射为中文标签
    seoCategoryLabel(category) {
      const map = {
        gambling: "赌博",
        porn: "色情",
        drug: "药品",
        product: "商品推广",
        seo: "SEO作弊",
        "fake scam": "假冒诈骗",
        "technology scam": "技术诈骗",
        "account sale scam": "账号买卖诈骗",
        "financial scam": "金融诈骗",
        "surrogacy scam": "代孕诈骗",
        other: "其他"
      };

      return map[category] || category || "-";
    },

    seoLocationLabel(location) {
      const map = { part: "正文", title: "标题", desc: "描述", other: "其他" };

      return map[location] || location || "-";
    },

    // 违规类型标签配色：按严重程度分档
    seoCategoryClass(category) {
      if (["gambling", "porn", "drug"].includes(category)) {
        return "cat-high";
      }
      if (category && category.includes("scam")) {
        return "cat-scam";
      }
      if (category === "seo") {
        return "cat-seo";
      }
      return "cat-normal";
    },

    toSeoRow(e) {
      return {
        round: e.round === undefined || e.round === null ? "-" : `第 ${e.round} 轮`,
        engine: e.engine || "-",
        scope: e.scope || "-",
        fqdn: e.fqdn || "-",
        location: this.seoLocationLabel(e.location),
        categoryText: this.seoCategoryLabel(e.category),
        categoryClass: this.seoCategoryClass(e.category),
        label: e.label || "-",
        title: e.title || "",
        // 标题过长时截断展示，完整内容放 tooltip
        titleShort: e.title && e.title.length > 40 ? `${e.title.slice(0, 40)}…` : (e.title || "-"),
        titleOverflow: !!(e.title && e.title.length > 40),
        url: e.url || "",
        query: e.query || "",
        desc: e.desc || "",
        descShort: e.desc && e.desc.length > 60 ? `${e.desc.slice(0, 60)}…` : (e.desc || "-"),
        descOverflow: !!(e.desc && e.desc.length > 60)
      };
    },

    toEventRow(e) {
      const confidence = this.normalizeConfidence(e.confidence);
      const model = String(e.source_model || "").toLowerCase();
      const allIps = Array.isArray(e.resolved_ips) ? e.resolved_ips.filter(Boolean) : [];
      // 归属地按 IP 顺序去重，避免同一省份重复占用列宽
      const allLocations = Array.isArray(e.ip_locations)
        ? Array.from(new Set(e.ip_locations.filter(Boolean)))
        : [];
      const totalAccess = Number(e.total_access_count);
      const dailyAccess = Array.isArray(e.daily_access_counts) ? e.daily_access_counts : [];

      return {
        timeText: this.formatTs(e.detect_time),
        domain: e.domain || "-",
        accessCountText: Number.isFinite(totalAccess) ? totalAccess.toLocaleString("en-US") : "-",
        // 悬浮展示每日解析次数明细
        dailyAccessText: dailyAccess
          .map(d => `${d.date}：${d.count}`)
          .join("\n"),
        resolvedIps: allIps.length ? allIps.slice(0, MULTI_CELL_LIMIT) : ["-"],
        ipOverflow: allIps.length > MULTI_CELL_LIMIT,
        ipMoreCount: Math.max(0, allIps.length - MULTI_CELL_LIMIT),
        resolvedAll: allIps.join("\n"),
        locations: allLocations.length ? allLocations.slice(0, MULTI_CELL_LIMIT) : ["-"],
        locationOverflow: allLocations.length > MULTI_CELL_LIMIT,
        locationMoreCount: Math.max(0, allLocations.length - MULTI_CELL_LIMIT),
        locationAll: allLocations.join("\n"),
        registeredText: e.registered_at ? String(e.registered_at) : "-",
        confidenceText: `${confidence.toFixed(1)}%`,
        confidenceWidth: `${confidence}%`,
        confidenceClass: confidence >= 80 ? "high" : confidence >= 50 ? "medium" : "low",
        domain_type: e.domain_type || "-",
        modelText: model.includes("gnn") ? "GNN" : "dnsspike",
        modelClass: model.includes("gnn") ? "model-gnn" : "model-spike"
      };
    },

    normalizeConfidence(value) {
      const num = Number(value);

      if (!Number.isFinite(num)) {
        return 0;
      }
      const percent = num <= 1 ? num * 100 : num;

      return Math.max(0, Math.min(100, percent));
    },

    // 索引构建时间（ISO 字符串）转成 YYYY-MM-DD 展示
    formatBuildTime(iso) {
      if (!iso) {
        return "-";
      }
      const d = new Date(iso);

      if (Number.isNaN(d.getTime())) {
        return String(iso).slice(0, 10);
      }
      const pad = n => String(n).padStart(2, "0");

      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    },

    formatTs(sec) {
      if (!sec) {
        return "-";
      }
      const d = new Date(Number(sec) * 1000);

      if (Number.isNaN(d.getTime())) {
        return "-";
      }
      const pad = n => String(n).padStart(2, "0");

      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }
  }
};
</script>

<style lang="less" scoped>
.malicious-container {
  width: 100%;
  min-height: var(--screen-height, 100vh);
  height: var(--screen-height, 100vh);
  background: url("../assets/background.png") no-repeat center center #000;
  background-size: cover;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}

.leftSider, .rightSider {
  position: fixed;
  z-index: 1;
  display: none;

  @media (min-width: 1366px) {
    display: block;
  }

  img {
    height: var(--screen-height, 100vh);
    width: auto;
  }
}

.leftSider { left: 0; top: 0; }
.rightSider { right: 0; top: 0; }

.page-update-time {
  position: absolute;
  top: 120px;
  left: 5%;
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
  z-index: 11;
}

.range-switch {
  position: absolute;
  top: 110px;
  right: 5%;
  z-index: 11;
}

.main-content {
  position: absolute;
  top: 180px;
  left: 0;
  right: 0;
  bottom: 80px;
  padding: 0 2% 80px;
  z-index: 10;
  overflow-y: scroll;
  scrollbar-gutter: stable;
  overflow-x: hidden;
  box-sizing: border-box;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (min-width: 768px) {
    top: 200px;
    padding: 0 4% 80px;
    gap: 20px;
  }

  @media (min-width: 1280px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr);
    grid-template-rows: minmax(calc(var(--screen-height, 100vh) - 640px), 1fr) auto auto;
    grid-template-areas:
      "left center right"
      "bottom bottom bottom"
      "beian beian beian";
    gap: 20px;
  }

  @media (min-width: 1366px) {
    padding: 0 5% 80px;
  }
}

.left-section {
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (min-width: 1280px) {
    grid-area: left;
    gap: 20px;
  }
}

.center-section {
  min-height: 400px;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;

  @media (min-width: 1280px) {
    grid-area: center;
  }
}

.right-section {
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (min-width: 1280px) {
    grid-area: right;
    gap: 20px;
  }
}

.bottom-section {
  min-width: 0;
  // 该区域内纵向排列多个通报卡片（恶意域名通报 / 黑帽SEO通报），需要卡片间隔
  display: flex;
  flex-direction: column;
  gap: 15px;

  // flex 列容器里 height:100% 会按容器高度而非内容算，这里改为按内容撑开
  .bottom-card {
    height: auto;
  }

  @media (min-width: 1280px) {
    grid-area: bottom;
    gap: 20px;
  }
}

.section-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: clamp(12px, 1.6vw, 18px);
  height: 100%;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

.left-card, .right-card {
  flex: 1;
  min-height: 260px;
}

.card-title {
  font-size: clamp(13px, 1.6vw, 17px);
  color: #fff;
  font-weight: bold;
  margin-bottom: 12px;
  padding-left: 10px;
  border-left: 4px solid #1890FF;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .title-main {
    display: inline-flex;
    align-items: center;
    min-width: 0;
  }

  .subtitle {
    font-size: clamp(11px, 1.3vw, 13px);
    font-weight: normal;
    color: rgba(255, 255, 255, 0.6);
    margin-left: 8px;

    .highlight {
      color: #FF6B6B;
      font-weight: bold;
      margin: 0 2px;
    }
  }
}

.chart-container {
  width: 100%;
  flex: 1;
  min-height: 220px;
}

// 右侧板块内的切换按钮
.tab-switch {
  margin-left: auto;
  display: inline-flex;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;

  button {
    border: none;
    outline: none;
    cursor: pointer;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: normal;
    background: transparent;
    color: rgba(255, 255, 255, 0.65);
    transition: background 0.2s, color 0.2s;

    & + button {
      border-left: 1px solid rgba(255, 255, 255, 0.18);
    }

    &:hover {
      color: #fff;
      background: rgba(24, 144, 255, 0.18);
    }

    &.active {
      background: #1890FF;
      color: #fff;
    }
  }
}

// 切换面板：占满卡片剩余高度
.tab-panel {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.cidr-table {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;

  /deep/ .el-table__body-wrapper {
    flex: 1 1 0;
    overflow-y: auto;
  }
}

.topo-chart {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}

.map-container {
  width: 100%;
  height: 100%;
  min-height: 400px;
}

.mal-pagination {
  margin-top: 8px;
  text-align: center;
}

.domain-list-preview {
  color: rgba(255, 255, 255, 0.75);
  cursor: default;
}

// 通报表格：多值单元格（解析IP / IP归属地）多列平铺
.multi-grid {
  display: grid;
  gap: 2px 10px;
  line-height: 1.5;
  cursor: default;

  .multi-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.more {
      color: #ffc53d;
    }
  }
}

.ip-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  font-family: Consolas, Menlo, Monaco, monospace;
  font-size: 12px;
}

.location-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  font-size: 12px;
}

// 置信度条
.confidence-bar {
  position: relative;
  width: 100%;
  height: 16px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  overflow: hidden;

  .confidence-fill {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 8px;

    &.high { background: linear-gradient(90deg, #ff7875, #f5222d); }
    &.medium { background: linear-gradient(90deg, #ffc53d, #fa8c16); }
    &.low { background: linear-gradient(90deg, #69c0ff, #1890ff); }
  }
}

// 解析次数
.access-count {
  color: #ffc53d;
  font-weight: bold;
  font-variant-numeric: tabular-nums;
  cursor: default;
}

.type-tag {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  background: rgba(255, 107, 107, 0.18);
  color: #ff9a9a;
}

.model-tag {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;

  &.model-spike {
    background: rgba(24, 144, 255, 0.18);
    color: #69c0ff;
  }

  &.model-gnn {
    background: rgba(250, 173, 20, 0.18);
    color: #ffc53d;
  }
}

// 表格深色主题
/deep/ .el-table {
  background: transparent;
  color: #fff;

  &::before { display: none; }

  th.el-table__cell {
    background: rgba(24, 144, 255, 0.1);
    color: #fff;
    font-weight: bold;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  tr {
    background: transparent;
    color: rgba(255, 255, 255, 0.8);
  }

  td.el-table__cell {
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }

  tbody tr:hover > td.el-table__cell {
    background: rgba(24, 144, 255, 0.12) !important;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }
}

.event-table {
  /deep/ .el-table__body-wrapper {
    max-height: clamp(380px, 48vh, 700px);
    overflow-y: auto;
  }

  /deep/ td.el-table__cell {
    padding: 6px 0;
  }

  /deep/ .cell {
    padding-left: 8px;
    padding-right: 8px;
  }
}

// 黑帽SEO通报表格
.seo-table {
  /deep/ .el-table__body-wrapper {
    max-height: clamp(380px, 48vh, 700px);
    overflow-y: auto;
  }

  /deep/ td.el-table__cell {
    padding: 6px 0;
  }

  /deep/ .cell {
    padding-left: 8px;
    padding-right: 8px;
  }
}

// 黑帽SEO 筛选栏
.seo-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;

  .seo-search {
    width: 220px;
    flex-shrink: 0;
  }

  /deep/ .el-input__inner {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.15);
    color: #fff;

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
  }

  /deep/ .el-select .el-input__inner {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.15);
    color: #fff;
  }

  // 下拉面板挂在 body 上，scoped 无法命中，这里给 el-select 的 popper 用全局类
}

.seo-domain {
  color: #69c0ff;
  font-family: Consolas, Menlo, Monaco, monospace;
  font-size: 12px;
  word-break: break-all;
}

.seo-title,
.seo-desc {
  color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
  cursor: default;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.seo-desc {
  color: rgba(255, 255, 255, 0.6);
}

.seo-link {
  color: #40a9ff;
  text-decoration: none;
  font-size: 12px;

  &:hover { color: #69c0ff; }
}

.engine-tag,
.scope-tag,
.location-tag {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
}

.engine-tag {
  background: rgba(24, 144, 255, 0.18);
  color: #69c0ff;
}

.scope-tag {
  background: rgba(82, 196, 26, 0.18);
  color: #95de64;
}

.location-tag {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.75);
}

.category-tag {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;

  &.cat-high {
    background: rgba(255, 107, 107, 0.2);
    color: #ff9a9a;
  }

  &.cat-scam {
    background: rgba(250, 173, 20, 0.2);
    color: #ffc53d;
  }

  &.cat-seo {
    background: rgba(114, 46, 209, 0.25);
    color: #b37feb;
  }

  &.cat-normal {
    background: rgba(255, 255, 255, 0.12);
    color: rgba(255, 255, 255, 0.75);
  }
}

// 分页深色
/deep/ .el-pagination {
  button, .el-pager li {
    background: transparent;
    color: rgba(255, 255, 255, 0.7);
  }

  .el-pager li.active { color: #FF6B6B; }
  .el-pagination__total { color: rgba(255, 255, 255, 0.7); }
}

.beian-footer {
  grid-area: beian;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 0 4px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 12px;

  a {
    color: rgba(255, 255, 255, 0.55);
    text-decoration: none;

    &:hover { color: #40a9ff; }
  }

  .beian-police-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .beian-police-logo {
    width: 14px;
    height: 14px;
  }
}
</style>

<style>
.domain-list-tooltip {
  max-width: 360px;
}
.domain-list-tooltip-content {
  white-space: pre-line;
  line-height: 1.6;
  max-height: 300px;
  overflow-y: auto;
}
</style>
